import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/guidelines',
)({
  loader: () => ({ breadcrumbTitle: 'Guidelines' }),
})
